import React from 'react'
import styles from './contact.module.css'

export default function Contact(props) {
    return (
        <div className="container">
            <h4 className="row"><u>Contact Us</u></h4>
            <div className="row my-3">
            <span> ☎ <a className={`${styles.contact}`} href={`tel:${props.number}`}>{props.number}</a></span>
            </div>
            <div className="row my-3">
            <span> 📧 <a className={`${styles.contact}`} href={`mailto:${props.email}`}>{props.email}</a></span>
            </div>
        </div>
    )
}
